import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const NavigationRight = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4143 0H8.58585L20.5858 12L8.58575 24H11.4142L22.7071 12.7071L23.4142 12L22.7071 11.2928L11.4143 0ZM4.41418 24H1.58575L13.5858 12L1.58585 0H4.41427L15.7071 11.2928L16.4142 12L15.7071 12.7071L4.41418 24Z"
      fill="currentColor"
    />
  </svg>,
  'NavigationRight'
);
